import { useMemo } from 'react';

import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import TextInput from 'src/components/TextInput';
import PopUp from 'src/components/design-system/PopUp';
import useReceiptDetails from 'src/hooks/useReceiptDetails';
import { getBgColor, getIcon } from 'src/utils/icons';

const DeliveryCompany = () => {
  const { updateFormData, errors, receiptData, isInProgress } = useReceiptDetails();
  const data = receiptData.deliveryCompanyName || '';
  const hasError = useMemo(
    () => !!errors.deliveryCompanyName.length,
    [errors.deliveryCompanyName.length]
  );

  return (
    <PopUp
      show={hasError}
      popupAlign={{ horizontal: 'left', vertical: 'bottom' }}
      anchorAlign={{ horizontal: 'left', vertical: 'center' }}
      content={<PopUpContentWrapper contents={errors.deliveryCompanyName} type="Error" />}
    >
      <div className={`p-1 ${getBgColor(errors.deliveryCompanyName)}`} title={data}>
        <div className="font-bold pb-1 flex flex-row text-[13px]">
          <p className="flex justify-center items-center">
            Delivery Company Name
            <span className="px-2">{getIcon(errors.deliveryCompanyName)}</span>
          </p>
        </div>
        {isInProgress ? (
          <TextInput
            value={data}
            onChange={(e) => {
              updateFormData('deliveryCompanyName', e.value);
            }}
            type="text"
            className="mt-1"
          />
        ) : (
          <p className="pl-1">{data}</p>
        )}
      </div>
    </PopUp>
  );
};

export default DeliveryCompany;
